















import Vue from "vue";
export default Vue.extend({
  props: {
    drageHandler: {
      type: String,
      required: true
    }
  }
});
